// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1GIY6","left":"InfoRow_left__2QLy1"};